import router from "@/router";
import {http} from "@/config/http";
import {throttle} from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
        ProposerData: {
            "customer_type": '',
            "title": '',
            "first_name": '',
            "last_name": '',
            "company_name": '',
            "business_reg_no": '',
            "company_reg_date": '',
            "prefered_language": '',
            "receive_notification":'',
            "prefered_communication": [],
            "adr_line1": '',
            "adr_line2": '',
            "adr_line3": '',
            "city": '',
            "contact_no_mobile": '',
            "contact_no_land": '',
            "email_address": '',
            "nic": '',
            "vat_no": '',
            "business_occupation": '',
            'source_of_income':'',
            "garaged_address": ''
        },
        OwnershipData: {
            "owner_name": '',
            "registered_owner_name": '',
            "financial_inst_name": ''
        },
        DriverData: {
            "vehicle_driven_by": ''
        },
        VehicleData: {
            "vehicle_type": '',
            "vehicle_usage": '',
            "fuel_type": '',
            "is_registered": null,
            "vehicle_no_format": '',
            "vehicle_number":'',
            "year_of_make": '',
            "vehicle_make":'',
            "vehicle_model":'',
            "chassis_no":'',
            "engine_no":'',
            "cubic_capacity":'',
            "seating_capacity":'',
            "market_value":'',
            "is_vehicle_imported_duty_free":'',
            "is_the_vehicle_modified":'',
            "is_vehicle_in_good_condition":'',
            "vehicle_condition":'',
            "vehicle_modified_details":'',
            "imported_value":'',
            "vehicleAccessories":[]
        },
        VehicleUsageData: [],
        CoverList: [],
        CoverData: {
            cover_type:'',
            cover_period_from: '',
            cover_period_to: '',
            no_cliam_bounus_years:0,
            bear_first_portion_accident_claim:'',
            first_portion_accident_claim_value:''
        },
        CustomerData: {
            signature : ''
        },
        ActionData:{},
        customer_errors: [],
        back: true,
        proposal_id: null,
        last_completed_step:0,
        proposal_status:null,
        is_signature_step:'',
        city_list: [],
        title_list: [],
        vehicle_type_list: [],
        vehicle_usage_list: [],
        fuel_type_list: [],
        year_of_make_list: [

        ],
        cover_type_list:[],
        vehicle_make_list: [],
        vehicle_model_list: [],
        insurance_cmp_list:[],
        vehicle_no_format_list:[],
        vehicle_driven_by_list:[],
        proposal_status_list:[],
        UploadTypes: [],
        UploadedDocs: [],
        UploadedDocsHistory: [],
        UploadedDocsActions: [],
        GlobalCfg:[],
        subLineCode:null,
        all_errors:[]
    };
};

const state = getDefaultState();

const getters = {};

const mutations = {
    /** clear state to initial state */
    clearObj(state) {
        Object.assign(state, getDefaultState());
    },
    setVehicleUsage(state, vehicle_usage) {
        state.VehicleData.vehicle_usage = vehicle_usage;
    },
    setVehicleType(state, vehicle_type) {
        state.VehicleData.vehicle_type = vehicle_type
    },
    setVehicleFuelType(state, fuel_type) {
        state.VehicleData.fuel_type = fuel_type
    },
    setYearOfMake(state, year_of_make) {
        state.VehicleData.year_of_make = year_of_make
    },
    setVehicleMake(state, vehicle_make) {
        state.VehicleData.vehicle_make = vehicle_make
    },
    setVehicleModel(state, vehicle_model) {
        state.VehicleData.vehicle_model = vehicle_model
    },
    setCityList(state, city) {
        state.ProposerData.city = city
    },
    setTitleList(state, title) {
        state.ProposerData.title = title
    },
    setInsuranceCmpList(state, financial_inst_name) {
        state.OwnershipData.financial_inst_name = financial_inst_name
    },
    setVehicleNoFormat(state, vehicle_no_format) {
        state.VehicleData.vehicle_no_format = vehicle_no_format
    },
    setProposalId(state, proposal_id) {
        state.proposal_id = proposal_id
    },
    setSignatureStep(state, status) {
        state.is_signature_step = status
    },
    setCoverType(state, cover_type){
        state.CoverData.cover_type = cover_type
    },
    setVehicleDrivenBy(state, vehicle_driven_by){
        state.DriverData.vehicle_driven_by = vehicle_driven_by
    },
    setParameterDataList(state, data){
        switch (data.type) {
            case "insurance_cmp_list":
                state.insurance_cmp_list = data.data;
                break
            case "city_list":
                state.city_list = data.data;
                break
            case "title_list":
                state.title_list = data.data;
                break
            case "vehicle_type_list":
                state.vehicle_type_list = data.data;
                break
            case "vehicle_usage_list":
                state.vehicle_usage_list = data.data;
                break
            case "fuel_type_list":
                state.fuel_type_list = data.data;
                break
            case "vehicle_make_list":
                state.vehicle_make_list = data.data;
                break
            case "vehicle_model_list":
                state.vehicle_model_list = data.data;
                break
            case "vehicle_no_format_list":
                state.vehicle_no_format_list = data.data;
                break
            case "cover_type_list":
                state.cover_type_list = data.data;
                break
            case "vehicle_driven_by_list":
                state.vehicle_driven_by_list = data.data;
                break
            case "proposal_status_list":
                state.proposal_status_list = data.data;
                break
            default:
                break
        }
    },

    setMakeYearList(state, data){
        state.year_of_make_list = data.data;
    },

    fillVehicleData(state, data) {
        if(data){
            state.ProposerData.adr_line1 = data.ownerAddr1[0];
            state.ProposerData.adr_line2 = data.ownerAddr2[0];
            state.OwnershipData.registered_owner_name = data.ownerName[0];
            state.VehicleData.chassis_no = data.chassisNo;
            state.VehicleData.engine_no = data.engineNo;
            state.VehicleData.seating_capacity = data.noOfSeats;
            //state.VehicleData.cubic_capacity = data.tareWeight;
        }
    },

    setProposalData(state, data){
        Object.assign(state.VehicleData, data.data.VehicleData);
        Object.assign(state.ProposerData, data.data.ProposerData);
        Object.assign(state.OwnershipData, data.data.OwnershipData);
        Object.assign(state.DriverData, data.data.DriverData);
        Object.assign(state.CoverData, data.data.CoverData);
        state.proposal_status = data.data.proposal_status;
        state.proposal_id = data.data.proposal_id;
        state.last_completed_step = data.data.last_completed_step;
        if(data.user_data.is_customer){
            state.ActionData.customer_form = true;
        }
    },

    setCoverList(state, data){
        if(data.data){
            state.CoverList = data.data;
            state.subLineCode = data.subline_code;
        }else{
            state.CoverList = [];
            state.subLineCode = '';
        }
    },

    setFormErrors(state, data) {
        state.all_errors = [];
        if (data) {
            state.all_errors = data.details;
        }
    },

    setUploadTypesObj(state, data) {
        state.UploadTypes = data;
    },

    setUploadedDocs(state, data) {
        state.UploadedDocs = data;
    },

    setUploadedDocsHistory(state, data) {
        state.UploadedDocsHistory = data;
    },

    setGlobalCfg(state, data) {
        state.GlobalCfg = data.data;
    },

    setExtraFittings(state, data) {
        state.VehicleData.vehicleAccessories = data.data;
    },
};

const actions = {
    /** Clear state data to initial state */
    async clearStateData({commit}) {
        commit("clearObj");
    },

    async saveProposalData({ commit }, reqData) {
        /** Cover data */
        let CoverData = {};
        let ProposerData = {};
        let VehicleData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CommonData = {};


        let data = {};
        /** Cover data */
        CoverData = state.CoverData;
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;
        CommonData = reqData;

        data = {
            ...data,
            /** Cover data */
            CoverData,
            ProposerData,
            VehicleData,
            DriverData,
            OwnershipData,
            CommonData
        };

        return new Promise((resolve, reject) => {
            http
                .post("proposal/save", {data})
                .then(response => {
                    if (!response.error) {
                        resolve(response);
                    } else {
                        commit(
                            "showAlert",
                            {
                                title: "Draft",
                                msg: response.data.meta.message,
                                type: "error",
                            },
                            {root: true}
                        );
                    }
                })
                .catch(error => {
                    alert(error);
                });
        });
    },

    draftProposalData: throttle(async function ({commit, state}) {
        let CoverData = {};
        let ProposerData = {};
        let VehicleData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CoverListData = [];

        let CommonData = {
            proposal_id: state.proposal_id
        };


        let data = {
        };
        /** Cover data */
        CoverData = state.CoverData;
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;
        CoverListData = state.CoverList

        data = {
            ...data,
            /** Cover data */
            CoverData,
            ProposerData,
            VehicleData,
            DriverData,
            OwnershipData,
            CommonData,
            CoverListData
        };

        if(state.proposal_id){
            await http
                .post("proposal/draft", {data}, {})
                .then((response) => {
                    if (!response.data.errors) {
                        // commit(
                        //     "showAlert",
                        //     {
                        //         title: "Draft",
                        //         msg: response.data.message,
                        //         type: "success",
                        //         position:"centerTop"
                        //     },
                        //     {root: true}
                        // );
                    } else {
                        commit("setFormErrors", response.data.errors);
                        commit(
                            "showAlert",
                            {
                                title: "Draft",
                                msg: response.data.errors.message,
                                type: "error",
                                position:"centerTop"
                            },
                            {root: true}
                        );
                    }
                })
                .catch((error) => {
                    commit(
                        "showAlert",
                        {
                            title: "Error",
                            msg: error,
                            type: "error",
                            position:"centerTop"
                        },
                        {root: true}
                    );

                });
        }
    }, process.env.VUE_APP_TIMEOUT_SEND_CHANGED_DATA),


    draftCoverData: throttle(async function ({commit, state}) {
        let CoverListData = [];

        let CommonData = {
            proposal_id: state.proposal_id
        };

        let data = {
        };

        CoverListData = state.CoverList

        data = {
            ...data,
            CommonData,
            CoverListData
        };

        if(state.proposal_id){
            await http
                .post("proposal/draft_cover_data", {data}, {})
                .then((response) => {
                    if (!response.error) {
                        // commit(
                        //     "showAlert",
                        //     {
                        //         title: "Draft",
                        //         msg: response.data.message,
                        //         type: "success",
                        //         position:"centerTop"
                        //     },
                        //     {root: true}
                        // );
                    } else {
                        // commit(
                        //     "showAlert",
                        //     {
                        //         title: "Draft",
                        //         msg: response.data.error.message,
                        //         type: "error",
                        //         position:"centerTop"
                        //     },
                        //     {root: true}
                        // );
                    }
                })
                .catch((error) => {
                    commit(
                        "showAlert",
                        {
                            title: "Error",
                            msg: error,
                            type: "error",
                            position:"centerTop"
                        },
                        {root: true}
                    );
                });
        }
    }, process.env.VUE_APP_TIMEOUT_SEND_CHANGED_DATA),



    setVehicleType({commit}, data) {
        commit("setVehicleType", data);
    },
    setVehicleUsage({commit}, data) {
        commit("setVehicleUsage", data);
    },
    setVehicleFuelType({commit}, data) {
        commit("setVehicleFuelType", data);
    },
    setYearOfMake({commit}, data) {
        commit("setYearOfMake", data);
    },
    setVehicleMake({commit}, data) {
        commit("setVehicleMake", data);
    },
    setVehicleModel({commit}, data) {
        commit("setVehicleModel", data);
    },
    setCityList({commit}, data) {
        commit("setCityList", data);
    },
    setTitleList({commit}, data) {
        commit("setTitleList", data);
    },
    setInsuranceCmpList({commit}, data) {
        commit("setInsuranceCmpList", data);
    },
    setVehicleNoFormat({commit}, data) {
        commit("setVehicleNoFormat", data);
    },
    setCoverType({commit}, data) {
        commit("setCoverType", data);
    },
    setProposalId({commit}, data) {
        commit("setProposalId", data);
    },
    setSignatureStep({commit}, data) {
        commit("setSignatureStep", data);
    },
    setCoverList({commit}, data) {
        commit("setCoverList", data);
    },
    setVehicleDrivenBy({commit}, data) {
        commit("setVehicleDrivenBy", data);
    },
    async getParameterDataList({commit}, data) {
        await http
            .post("parameters/ins_cmp_list", data)
            .then((response) => {
                if (!response.error) {
                    commit("setParameterDataList", response.data);
                } else {

                }
            })
            .catch((error) => {
            });
    },

    async setProposalSeen({commit}, data) {
        await http
            .post("proposal/set_proposal_seen", data)
            .then((response) => {
                if (!response.error) {
                    //commit("setParameterDataList", response.data);
                } else {

                }
            })
            .catch((error) => {
            });
    },

    async fillVehicleData({commit}, data) {


        return new Promise((resolve, reject) => {

            let param = {
                'vehicle_no' : state.VehicleData.vehicle_number,
                'vehicle_no_format' : state.VehicleData.vehicle_no_format
            };

            http
                .post("proposal/vehicle_info", param)
                .then((response) => {
                    if (response.error) {

                    } else {
                        commit("fillVehicleData", response.data.data);
                    }
                    resolve(response);
                })
                .catch((error) => {
                    resolve(error);
                });
        });
    },

    async getProposalData({commit}, data) {
        return new Promise((resolve, reject) => {
              http
                .post("proposal/get_proposal_data", data)
                .then((response) => {
                    if (!response.error) {
                        commit("setProposalData", response.data);
                        resolve(response);
                    } else {

                    }
                })
                .catch((error) => {
                });
        });
    },

    async sendCustomerLink({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/send_link", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    alert(error);
                });
        });
    },

    async sendCustomerLinkFinal({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/send_link_final", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    alert(error);
                });
        });
    },

    async cloneProposalData({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/clone_proposal", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    alert(error);
                });
        });
    },

    async validateSendLink({ commit }, reqData) {
        let ProposerData = {};
        let VehicleData = {};
        let CommonData = {
            proposal_id: state.proposal_id
        };
        let data = {
        };
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;

        data = {
            ...data,
            ProposerData,
            VehicleData,
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/validate_sendlink",{data})
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async validateFinal({ commit }, reqData) {
        let ProposerData = {};
        let VehicleData = {};
        let CoverData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CommonData = {
            proposal_id: state.proposal_id
        };
        let data = {
        };
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        CoverData = state.CoverData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;

        data = {
            ...data,
            ProposerData,
            VehicleData,
            CoverData,
            OwnershipData,
            DriverData
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/validate_final",{data})
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async validateCustomerStep({ commit }, reqData) {
        let ProposerData = {};
        let VehicleData = {};
        let CoverData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CommonData = {
            proposal_id: state.proposal_id
        };
        let data = {
        };
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        CoverData = state.CoverData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;

        data = {
            ...data,
            ProposerData,
            VehicleData,
            CoverData,
            OwnershipData,
            DriverData,
            CommonData
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/validate_customer_step",{data})
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async validateVehicleStep({ commit }, reqData) {
        let ProposerData = {};
        let VehicleData = {};
        let CoverData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CommonData = {
            proposal_id: state.proposal_id
        };
        let data = {
        };
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        CoverData = state.CoverData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;

        data = {
            ...data,
            ProposerData,
            VehicleData,
            CoverData,
            OwnershipData,
            DriverData,
            CommonData
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/validate_vehicle_step",{data})
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async validateCoverStep({ commit }, reqData) {
        let ProposerData = {};
        let VehicleData = {};
        let CoverData = {};
        let OwnershipData = {};
        let DriverData = {};
        let CommonData = {
            proposal_id: state.proposal_id
        };
        let data = {
        };
        ProposerData = state.ProposerData;
        VehicleData = state.VehicleData;
        CoverData = state.CoverData;
        OwnershipData = state.OwnershipData;
        DriverData = state.DriverData;

        data = {
            ...data,
            ProposerData,
            VehicleData,
            CoverData,
            OwnershipData,
            DriverData,
            CommonData
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/validate_cover_step",{data})
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async getCustomerSignature({ commit }, reqData) {

        return new Promise((resolve, reject) => {
            http
                .post("proposal/get_customer_signature",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },
    async customerRejectProposal({ commit }, reqData) {

        return new Promise((resolve, reject) => {
            http
                .post("proposal/customer_reject_proposal",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async rejectProposalAgent({ commit }, reqData) {

        return new Promise((resolve, reject) => {
            http
                .post("proposal/agent_reject_proposal",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async customerCompleteProposal({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/customer_complete_proposal",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },
    async proposalTransferToAgent({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/proposal_transfer_to_agent",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },
    async customerConfirmProposal({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/customer_confirm_proposal",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },
    async approveProposalAgent({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/approve_proposal_agent",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async transferProposalToCustomer({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/transfer_proposal_to_customer",reqData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async getCoverList({ commit }, reqData) {
        let vehicleData = {
            vehicle_class:state.VehicleData.vehicle_type,
            fuel_type:state.VehicleData.fuel_type,
            vehicle_usage:state.VehicleData.vehicle_usage,
            cover_type:state.CoverData.cover_type,
            proposal_id:state.proposal_id
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/get_cover_list",vehicleData)
                .then(response => {
                    if (response.data.success) {
                        commit("setFormErrors", "");
                    } else if (response.data.error) {
                        //commit("setFormErrors", response.data.error);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    /*Upload related functions*/

    async getUploadTypes({ commit }) {
        await http
            .post("parameters/upload_types", null, {})
            .then(response => {
                if (response.data.meta.status == "true") {
                    commit("setUploadTypesObj", response.data.data);
                } else {
                    let error = "Error : Get document types Failed";
                    commit(
                        "showAlert",
                        {
                            title: "Draft",
                            msg: error,
                            type: "error"
                        },
                        { root: true }
                    );
                }
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error",
                        msg: error,
                        type: "error"
                    },
                    { root: true }
                );
            });
    },

    async UploadFile({ commit }, payload) {
        await http
            .post("proposal/upload_doc", payload)
            .then(response => {
                if (!response.data.error) {
                    commit(
                        "showAlert",
                        {
                            title: "Success",
                            msg: response.data.data.message,
                            type: "success"
                        },
                        { root: true }
                    );
                    commit("setUploadedDocs", response.data.data.files);
                    commit("setUploadedDocsHistory", response.data.data.history);
                } else {
                    let error = "Error : File Upload Failed";
                    commit(
                        "showAlert",
                        {
                            title: "Error",
                            msg: response.data.error.message,
                            type: "error"
                        },
                        { root: true }
                    );
                }
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error",
                        msg: error,
                        type: "error"
                    },
                    { root: true }
                );
            });
    },

    async RemoveFile({ commit }, payload) {
        return new Promise((resolve, reject) => {
             http
                .post("proposal/remove_doc", payload)
                .then(response => {
                    if (!response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Success",
                                msg: response.data.data.message,
                                type: "success"
                            },
                            { root: true }
                        );
                    } else {
                        commit(
                            "showAlert",
                            {
                                title: "Error",
                                msg: response.data.error.message,
                                type: "error"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error",
                            msg: error,
                            type: "error"
                        },
                        { root: true }
                    );
                });
        });
    },

    async loadUploadedFiles({ commit }, payload) {
        await http
            .post("proposal/get_upload_doc", payload)
            .then(response => {
                if (response.data.meta.status == "true") {
                    commit("setUploadedDocs", response.data.data.files);
                    commit("setUploadedDocsHistory", response.data.data.history);
                } else {
                    let error = "Error : Load uploaded files failed";
                    commit(
                        "showAlert",
                        {
                            title: "Draft",
                            msg: error,
                            type: "error"
                        },
                        { root: true }
                    );
                }
            })
            .catch(error => {
                commit(
                    "showAlert",
                    {
                        title: "Error",
                        msg: error,
                        type: "error"
                    },
                    { root: true }
                );
            });
    },


    async getConfigValues({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("parameters/cnf_values",reqData)
                .then(response => {
                    if (!response.errors) {
                        commit("setFormErrors", "");
                        commit("setGlobalCfg", response.data);
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async addExtraFittings({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/add_extra_fittings",reqData)
                .then(response => {
                    if (!response.data.errors) {
                        commit("setFormErrors", "");
                        let pData = {
                            proposal_id : state.proposal_id
                        };
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async removeExtraFittings({ commit }, reqData) {
        let data = {
            id : reqData.id
        };
        return new Promise((resolve, reject) => {
            http
                .post("proposal/remove_extra_fittings",data)
                .then(response => {
                    if (!response.errors) {
                        commit("setFormErrors", "");
                        let pData = {
                            proposal_id : state.proposal_id
                        };
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },


    async getExtraFittings({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/get_extra_fittings",reqData)
                .then(response => {
                    if (!response.errors) {
                        commit("setFormErrors", "");
                        commit("setExtraFittings", response.data);
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async downloadPdf({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("proposal/download_pdf",reqData)
                .then(response => {
                    if (!response.errors) {
                        commit("setFormErrors", "");
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

    async getMakeYearList({ commit }, reqData) {
        return new Promise((resolve, reject) => {
            http
                .post("parameters/get_make_of_year",reqData)
                .then(response => {
                    if (!response.errors) {
                        commit("setMakeYearList", response.data);
                    } else if (response.data.errors) {
                        commit("setFormErrors", response.data.errors);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit(
                        "showAlert",
                        {
                            title: "Error!",
                            msg: "Oops!.Error occured.Please contact system administrator.",
                            type: "error",
                            position: "centerTop"
                        },
                        {root: true}
                    );
                });
        });
    },

};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
